export default "__VITE_ASSET__H5ii0yDn__"